module.exports = __webpack_public_path__ + "static/media/gett_delivery_wide.abb950ab.png";